import { Firestore } from './firestore'
import { collection, getDocs } from 'firebase/firestore'

export class News {
  // 最新のニュースを取得
  static async getAll () {
    const snapshot = await getDocs(collection(Firestore.getDb(), 'build-note-all-rss'))
    const result = snapshot.docs.map((doc) => doc.data())

    return result
  }

  // 固定化されたニュースを取得
  static async getPickup () {
    const snapshot = await getDocs(collection(Firestore.getDb(), 'build-note-pickup-rss'))
    const result = snapshot.docs.map((doc) => doc.data())

    return result
  }

  // Webinarを取得
  static async getWebinar () {
    const snapshot = await getDocs(collection(Firestore.getDb(), 'build-note-webinar-rss'))
    const result = snapshot.docs.map((doc) => doc.data())

    return result
  }
}
